module.exports = __webpack_public_path__ + "02_short_brown.d5bd0b6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_short_brown.png
// module id = xjSp
// module chunks = 0